import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const autosuggestViewAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.AutosuggestView],
  restrictedBannersAllowed: true,
}

export const autosuggestModifyAccessControl: DomainAccessControlConfig = {
  permissions: [Permission.AutosuggestModify],
  restrictedBannersAllowed: true,
}
